import React from 'react';
import { Table, Form } from 'antd';
import FormCustomRating from '../FormCustomRating/FormCustomRating';

const RatingTable = ({ label, name, rows, customIcons, disabled, ...rest }) => {
  const columns = [
    {
      title: 'Kategória',
      dataIndex: 'category',
      editable: false, //Kategoria je ln na zobrazenie, nie je editovateľná
    },
    {
      title: 'Hodnotenie',
      dataIndex: 'rating',
      editable: true,
    },
  ];

  return (
    <Form.Item label={label} name={name}>
      <Table
        bordered
        pagination={false}
        dataSource={rows}
        columns={columns.map((col) => ({
          ...col,
          render: (text, record) => {
            if (col.editable) {
              return (
                <Form.Item
                  name={[name, record.key, 'rating']}
                  style={{ marginBottom: 0 }}
                >
                  <FormCustomRating
                    name={[name, record.key, col.dataIndex]}
                    value={record.rating}
                    allowHalf={true}
                    customIcons={record.customIcons ?? customIcons}
                    disabled={disabled}
                    onChange={(value) => {
                      record.rating = value; // Aktualizujeme rating priamo v riadku -> row
                    }}
                  />
                </Form.Item>
              );
            }
            return text; //Zobrazí statický  text pre needitovateľné bunky
          },
        }))}
        rowKey="key"
      />
    </Form.Item>
  );
};

export default RatingTable;
